module.exports = __webpack_public_path__ + "img/next.279cde3a.png";